import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { CorreiosAuth, CorreiosServices } from 'src/app/services/correios.services';
import { DialogService } from 'src/app/services/dialog.service';
import { GlobalErrorHandler } from 'src/app/services/GloabalErrorHandler.services';
import { HTTPService } from 'src/app/services/http.service';
import { LanguageServices } from 'src/app/services/LanguageServices';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { PromptSaveDialogComponent } from 'src/app/system-utils/prompt-save-dialog/prompt-save-dialog.component';
import { DateUtils } from 'src/app/system-utils/utils/DateUtils';


export interface Range{
    CODECOMPANY:number;
    CODEMKTP:number;
    SERVICENAME:string;
    ETQINI:number;
    ETQFIN:number;
    SIGLA:string;
    CODSERV:string;
}

@Component({
    selector: 'cep-range',
    templateUrl: './cep-range.component.html',
    styleUrls: ['./cep-range.component.scss'],
    standalone: false
})
export class CepRangeComponent implements OnInit {

  
  @Input() codecompany:number;
  @Input() codecontract:number;
  @Input() servico:Object;
  @Input() correiosAuth:CorreiosAuth;
  @Input() eventUserConfig: Observable<object>;
  private eventsSubscription: Subscription;

  rangeList:Range[] = [];
  constructor(private http:HTTPService, private dialog:DialogService, private cs:CorreiosServices,
    public datapipe:DatePipe, private snackService:SnackbarService, private ls:LanguageServices) { }

  ngOnInit(): void {
      
      this.eventsSubscription = this.eventUserConfig.subscribe(data=>{
          this.findRange();
      });
  }

  ngOnDestroy(){
    this.eventsSubscription.unsubscribe();
  }

  findRange(){
    let ob = {
      "entityName":"Mktpetqrange",
      "sql":`SELECT * FROM MKTPETQRANGE A  WHERE A.CODECOMPANY=${this.codecompany}`
    }
 
    this.http.post(ob,'JsonBrokerServices/findnative',false,true,true).subscribe(con=>{
      this.rangeList  = con['SQL'] || []; // evita nzData nulo quando nao ha intervalos
    })
  }

  getRange(){

      if ( this.servico == null ){
        this.snackService.showError(this.ls.instant('correios.range.noService'));
        return;
      }
      //this.dialog.openGenericDialog(PromptSaveDialogComponent)
      this.dialog.openGenericDialog(PromptSaveDialogComponent,{message:this.ls.instant('correios.range.qtyRequired'), lable:this.ls.instant('correios.range.qty')},(data)=>{
          let qtdEtiquetas = data['nome'];
          if ( qtdEtiquetas){
            this.cs.getRange(this.codecompany,this.codecontract, this.servico['codigo'], qtdEtiquetas, this.correiosAuth).then(data=>{
                
                let doc:Document = new DOMParser().parseFromString(data as string,'text/xml');
                let result = doc.evaluate("//return",doc);
                let node = result.iterateNext();
                let range = node.textContent;
                if ( range ){
                  let inicio  = range.split(',')[0];
                  let final  = range.split(',')[1];
                  let codServ:string  = inicio.substring(0,2);
                  let valueInicio:string  = inicio.substring(2).split(' ')[0];
                  let valueFinal:string  = final.substring(2).split(' ')[0];
                  let hoje  = this.datapipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss.SSS'); 

                  let jsonSave:Object = {
                    "entityName":"Mktpetqrange",
                    "CODECOMPANY": this.codecompany,
                    "CODEMKTP":87,
                    "SERVICENAME":this.servico['descricao'],
                    "ETQINI": valueInicio,
                    "ETQFIN": valueFinal,
                    "SIGLA":"BR",
                    "CODSERV":codServ,
                    "STATUS":"1",
                    "DTCREATED":hoje
                    }

                    
                    this.http.post(jsonSave,'JsonBrokerServices/save',false,true,false).subscribe(data=>{
                          this.snackService.showSuccess(this.ls.instant('correios.range.created'));
                          this.findRange(); // atualiza a lista com o novo intervalo
                    });
                }
            }).catch( error=>{
                GlobalErrorHandler.showError(error);
            })
          }
      });
  }

}
